import React, { useContext, useRef, useEffect, useState } from 'react';
import '../../css/Layout.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
/* 01.06 navigation 기능추가 import */
import {Navigation} from 'react-minimal-side-navigation';
import 'react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css';
import '../../css/Nav.css';

export default function TAB_Nav( {getNavFlag, handleNavFlagFalse} ) {

  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const [menuArray, setmenuArray] = useState([]);
  let menuArr = [];
  let navList = [];

  /* [START] - 외부 영역 클릭 시 Nav 닫기 */
  useEffect(() => {
    if(localStorage.getItem("nav") !== null){
      navList = JSON.parse(localStorage.getItem("nav"));
    }
    handleSelect();
    document.addEventListener("mousedown", Clickout);
    return () => {
      document.removeEventListener("mousedown", Clickout);
    };
  }, []);

  useEffect(() => {
    if(localStorage.getItem("nav") !== null){
      if(menuArray.reduce((total, item) => total + item.subNav.length, 0) !== JSON.parse(localStorage.getItem("nav")).filter((item) => item.upper_menu_yn === 'N').length){
        var device_type = localStorage.getItem("deviceType");
        navList = JSON.parse(localStorage.getItem("nav"))
        menuArr = [];
        
        for(var i=0; i<navList.length; i++){
          if(navList[i].menu_nav_yn == 'Y'){ 
            if(navList[i].upper_menu_yn == 'Y' && (device_type === 'M' || navList[i].lower_menu_yn == 'N' || (device_type !== 'M' && navList.filter((item) => item.upper_menu_id === navList[i].menu_id).length > 0))){
              menuArr.push({ 
                value : navList[i].menu_id,
                title : navList[i].menu_nav_name,
                itemId : navList[i].menu_item_id,
                subNav : [] 
              });
            }else{
              if(menuArr != null){
                menuArr.forEach(element => {
                  if(element.value == navList[i].upper_menu_id){
                    element.subNav.push({
                      title: navList[i].menu_nav_name,
                      itemId: navList[i].menu_item_id
                    });
                  }
                })
              }
            }
          }
        }
        setmenuArray(menuArr)
      }
    }
  });

  const Clickout = (eve) => {
    if (sidebarRef.current && !sidebarRef.current.contains(eve.target)) {
      handleNavFlagFalse()
    }
  };
  /* [END] - 외부 영역 클릭 시 Nav 닫기 */

  const handleSelect = () => {

    var device_type = localStorage.getItem("deviceType");
    var resource_id = localStorage.getItem("resource_id");
    
    if(device_type == 'M' && resource_id == 0){
      device_type = "M"; 
    }else if(resource_id != 0){
      device_type = "T"; 
    }else{
      device_type = "P"; 
    }

    if(localStorage.getItem("nav") === null){
      setmenuArray([]);
      axios.get('/api/Common/NavList',
        { params : { device_type: device_type } }, 
        { withCredentials: true }
      )
      .then((response) => {
        localStorage.setItem("nav", JSON.stringify(response.data));
        for (var i = 0; i < response.data.length; i++) {
            
          // 🚨 수정 포인트: response.data[i].menu_nav_yn == 'Y' 조건 추가 (빈 메뉴 방어)
          if(response.data[i].menu_nav_yn == 'Y') {
            if(response.data[i].upper_menu_yn == 'Y' && (device_type === 'M' || response.data[i].lower_menu_yn == 'N' || (device_type !== 'M' && response.data.filter((item) => item.upper_menu_id === response.data[i].menu_id).length > 0))){
              menuArr.push({ 
                value : response.data[i].menu_id,
                title : response.data[i].menu_nav_name,
                itemId : response.data[i].menu_item_id,
                subNav : [] 
              });
            }else{
              if(menuArr != null){
                menuArr.forEach(element => {
                  if(element.value == response.data[i].upper_menu_id){
                    element.subNav.push({
                      title: response.data[i].menu_nav_name,
                      itemId: response.data[i].menu_item_id
                    });
                  }
                })
              }
            }
          }
        }
      });
    }else{
      for(var i=0; i<navList.length; i++){
          
        // 🚨 수정 포인트: navList[i].menu_nav_yn == 'Y' 조건 추가 (빈 메뉴 방어)
        if(navList[i].menu_nav_yn == 'Y') {
          if(navList[i].upper_menu_yn == 'Y' && (device_type === 'M' || navList[i].lower_menu_yn == 'N' || (device_type !== 'M' && navList.filter((item) => item.upper_menu_id === navList[i].menu_id).length > 0))){
            menuArr.push({ 
              value : navList[i].menu_id,
              title : navList[i].menu_nav_name,
              itemId : navList[i].menu_item_id,
              subNav : [] 
            });
          }else{
            if(menuArr != null){
              menuArr.forEach(element => {
                if(element.value == navList[i].upper_menu_id){
                  element.subNav.push({
                    title: navList[i].menu_nav_name,
                    itemId: navList[i].menu_item_id
                  });
                }
              })
            }
          }
        }
      }
    }
    setmenuArray(menuArr)
  }

  return (
    <nav className={`nav ${getNavFlag === true? "show" : "hide"}`} ref={sidebarRef} style={{minHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
        <Navigation
            onSelect={({itemId}) => {
              let check_url = itemId;

              if(check_url[0] == '/'){
                navigate(check_url);
                handleNavFlagFalse();
              }
              
            }}
            items={menuArray}
          />
    </nav>
  );
};